import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPcgamingwikiComponent } from './simple-icons-pcgamingwiki.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPcgamingwikiComponent ],
    exports:      [ SimpleIconsPcgamingwikiComponent ],
    bootstrap:    []
})
export class SimpleIconsPcgamingwikiModule {}
